import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import moment from "moment/moment";
import currencyFormatter from "currency-formatter";

const _FM_ReservationEzeepricesListComponent = (props) => {

  const {t, i18n} = props;
  const prices = props.prices || {};
  const totals = prices.totals || {};
  const guestCounts = prices.guestCounts || prices.guest_counts || {};
  const currencyCode = prices.currencyCode || prices.currency_code;
  const capturedAt = prices.capturedAt || prices.captured_at;

  useEffect(() => {
    if (props.errors && props.errors[0]) {
      props.errors.map(error => {
        window.App.customToastShow('warn', error, '', 10000)
      })
    }
    console.log(props)
  }, [window.App.state.rerenderReservationEzeepricesList])

  return (
    <Panel className={"reservation-ezeeprices-list p-mt-3"}>
      <h3 className={"p-mt-0"}>
        {t('ezee_prices')}
      </h3>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="captured_at">{t('captured_at')}</label>
            <span className="p-d-block p-text-bold">
             {capturedAt ? moment.utc(capturedAt).local().format(t('YYYY-MM-DD HH:mm:ss')) : ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="currency_code">{t('currency')}</label>
            <span className="p-d-block p-text-bold">
             {currencyCode}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="guest_counts">{t('guest_counts')}</label>
            <span className="p-d-block p-text-bold">
             {t('adult')}: {guestCounts?.adult}
              <br/>
              {t('child')}: {guestCounts?.child}
              <br/>
              {t('expected_guest_count')}: {guestCounts?.expectedGuestCount ?? guestCounts?.expected_guest_count}
            </span>
          </div>
        </div>
      </div>
      <h3 className={"p-mt-0"}>
        {t('totals')}
      </h3>
      <table className={"w-100 p-datatable-table table-striped item-add-table"} cellPadding={0} cellSpacing={0}
             border={0}>
        <tr>
          <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('total_amount_after_tax')}</th>
          <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('total_amount_before_tax')}</th>
          <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('total_tax')}</th>
          <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('total_discount')}</th>
          <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('total_extra_charge')}</th>
          <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('total_payment')}</th>
        </tr>
        <tr>
          <td className={"p-text-right p-text-nowrap"}>
            {currencyFormatter.format(totals.totalAmountAfterTax ?? totals.total_amount_after_tax ?? 0, {
              precision: t('currency_precision'),
              symbol: t('currency_symbol'),
              decimal: t('currency_decimal'),
              thousand: t('currency_thousand'),
            })} {currencyCode}
          </td>
          <td className={"p-text-right p-text-nowrap"}>
            {currencyFormatter.format(totals.totalAmountBeforeTax ?? totals.total_amount_before_tax ?? 0, {
              precision: t('currency_precision'),
              symbol: t('currency_symbol'),
              decimal: t('currency_decimal'),
              thousand: t('currency_thousand'),
            })} {currencyCode}
          </td>
          <td className={"p-text-right p-text-nowrap"}>
            {currencyFormatter.format(totals.totalTax ?? totals.total_tax ?? 0, {
              precision: t('currency_precision'),
              symbol: t('currency_symbol'),
              decimal: t('currency_decimal'),
              thousand: t('currency_thousand'),
            })} {currencyCode}
          </td>
          <td className={"p-text-right p-text-nowrap"}>
            {currencyFormatter.format(totals.totalDiscount ?? totals.total_discount ?? 0, {
              precision: t('currency_precision'),
              symbol: t('currency_symbol'),
              decimal: t('currency_decimal'),
              thousand: t('currency_thousand'),
            })} {currencyCode}
          </td>
          <td className={"p-text-right p-text-nowrap"}>
            {currencyFormatter.format(totals.totalExtraCharge ?? totals.total_extra_charge ?? 0, {
              precision: t('currency_precision'),
              symbol: t('currency_symbol'),
              decimal: t('currency_decimal'),
              thousand: t('currency_thousand'),
            })} {currencyCode}
          </td>
          <td className={"p-text-right p-text-nowrap"}>
            {currencyFormatter.format(totals.totalPayment ?? totals.total_payment ?? 0, {
              precision: t('currency_precision'),
              symbol: t('currency_symbol'),
              decimal: t('currency_decimal'),
              thousand: t('currency_thousand'),
            })} {currencyCode}
          </td>
        </tr>
      </table>
    </Panel>
  )
}
export default withTranslation('common')(_FM_ReservationEzeepricesListComponent);
